import {useRunWorkflow} from '@/biz/workflow.jsx'
import {Alert, useOpenModal} from '@/components/Modal/index.mjs'
// import metaBizNode from '../../metaBizNode.mjs'
import runAsync from "@/script/runAsync.mjs";
import useHTTP from "@/hooks/useHTTP.mjs";

export const aiGenerateWebCode = () => () => {
    const openModal = useOpenModal()
    const runWorkflow = useRunWorkflow()
    const http = useHTTP();

    return async function (nodeData) {
        // 请求接口判断是否存在用户界面
        const data = await runAsync(
            async () => {
                return await http.get(`/aiExport/expBdUis?dpId=${nodeData.pkid}`)
            }, {
                error: {content: (err) => `查询失败: ${err.message}`},
                loading: {show: true},
                success: {show: false},
            });
        if (!data?.length) {
            await openModal(
                <Alert type="error">
                    当前程序模块下不存在用户界面，请先创建用户界面。
                </Alert>
            )

            return
        }
        

        const {bdName, bdNo, pkid, prjId, rev, ssName, sVer} = nodeData

        const bizMap = {
            dpId: pkid,
            dpNames: [bdName ?? ssName],
            prjId,
            // patternId: this.data.prjPatternId,
            rev,
            sVer,
        }

        runWorkflow({bizMap, scene: 'CODE_GENERATION_WEB'})
    }
}
